import { W8BenFormEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';

import { W8BenFormFormType } from '../../../client/forms/w8BenFormForm';

export const parseW8BENFormValue = (t: TFunc, data?: W8BenFormEntity) => {
  const values: W8BenFormFormType['W8BenForm'] = {
    isUSSecuritiesInvestmentPlanned: yesOrNotOption(
      t,
      data?.isUSSecuritiesInvestmentPlanned
    ),
    files: data?.files,
  };

  return values;
};
